module.exports = __webpack_public_path__ + "img/citizen.9177a8dd.gif";